import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';

export interface DropdownOption {
  value: string | number;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropDownComponent),
      multi: true,
    },
  ],
})
export class DropDownComponent implements ControlValueAccessor {
  @Input() options: DropdownOption[] = [];
  @Input() label: string = '';
  @Input() placeholder: string = 'Select an option';
  @Input() name: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() class: string = '';
  @Input() id: string = '';
  @Input() multiple: boolean = false;
  @Input() loading: boolean = false;

  value: string | number | null = null;
  selectedValues: (string | number)[] = [];
  touched: boolean = false;
  formControl = new FormControl();

  // ControlValueAccessor implementation
  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    if (this.multiple) {
      this.selectedValues = Array.isArray(value) ? value : [];
      this.formControl.setValue(this.selectedValues);
    } else {
      this.value = value;
      this.formControl.setValue(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  onSelectionChange(event: any): void {
    if (this.multiple) {
      this.selectedValues = event.value;
      this.onChange(this.selectedValues);
    } else {
      this.value = event.value;
      this.onChange(this.value);
    }
    this.onTouched();
  }

  onBlur(): void {
    this.touched = true;
    this.onTouched();
  }

  clearSelection(): void {
    if (this.multiple) {
      this.selectedValues = [];
      this.formControl.setValue([]);
      this.onChange(this.selectedValues);
    } else {
      this.value = null;
      this.formControl.setValue(null);
      this.onChange(this.value);
    }
    this.touched = true;
    this.onTouched();
  }
}
